module.exports = __webpack_public_path__ + "media/images/flags/4x3/lbr-4af9961baf121d5c0de8603fdb5abdb0.svg";